export class AppUserOtpInfo {
  public email: string = "";
  public phoneVerification: string = "";
  public userDeviceToken: string = "";
  public sessionToken: string = "";
  public jobPostingId: string = "";
  public referralCode: string = "";
  public phoneNumber: string = "";
}
